export interface HeadSeo {
  title: string;
  description: string;
  keywords: string;
  canonical: string;
  image?: string;
  type?: 'website' | 'article';
  siteName?: string;
}

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  if (!content) return;
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function removeMeta(attr: 'name' | 'property', key: string) {
  const el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (el) el.remove();
}

function upsertCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function applyHeadSeo(seo: HeadSeo) {
  const siteName = seo.siteName || 'CSSBuy Spreadsheet';

  document.title = seo.title;
  upsertMeta('name', 'description', seo.description);
  upsertMeta('name', 'keywords', seo.keywords);
  upsertCanonical(seo.canonical);

  upsertMeta('property', 'og:title', seo.title);
  upsertMeta('property', 'og:description', seo.description);
  upsertMeta('property', 'og:type', seo.type || 'website');
  upsertMeta('property', 'og:url', seo.canonical);
  upsertMeta('property', 'og:site_name', siteName);

  upsertMeta('name', 'twitter:card', seo.image ? 'summary_large_image' : 'summary');
  upsertMeta('name', 'twitter:title', seo.title);
  upsertMeta('name', 'twitter:description', seo.description);

  if (seo.image) {
    upsertMeta('property', 'og:image', seo.image);
    upsertMeta('name', 'twitter:image', seo.image);
  } else {
    removeMeta('property', 'og:image');
    removeMeta('name', 'twitter:image');
  }
}

export function resetHeadSeo() {
  document.title = 'Page Not Found | CSSBuy Spreadsheet';
  removeMeta('property', 'og:image');
  removeMeta('name', 'twitter:image');
}